/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1441
 */

var /* [auto-meaningful-name] */require_502_$$_$$_$$_$$_$$_$$_$$_253_2588_1461_2585_502_index$Uint8Array = require(/* 502 */"../../../../../../../253/2588/1461/2585/502/index").Uint8Array
module.exports = require_502_$$_$$_$$_$$_$$_$$_$$_253_2588_1461_2585_502_index$Uint8Array
